import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './uiSlice';
import studyModeReducer from './studyModeSlice';
import studyMaterialReducer from './studyMaterialsSlice'
import benefitsReducer from './benefitsSlice';
import hoursReducer from './hoursSlice'
import recordingsReducer from './recordingsSlice'
import feedbacksReducer from './feedbackSlice'
import leadsReducer from './leadsSlice'
import learnersReducer from './learnersSlice'
import learningBundlesReducer from './learningBundlesSlice'
import learningModulesReducer from './learningModulesSlice'
import trainingCardsReducer from './trainingCardsSlice'
import faqReducer from './faqSlice'
import trainingSchedulesReducer from './trainingSchedulesSlice'
import domainsReducer from "./domainsSlice";
import trainersReducer from "./trainersSlice";
import empDataReducer from "./empDataSlice";
import ictCostReducer from "./ictCostSlice";
import accommodationsReducer from "./accommodationSlice";
import travelDataReducer from "./travelDataSlice";
import tourDataReducer from "./tourDataSlice";
import dcDataReducer from "./dcDataSlice";
import ictSalesCardReducer from './ictSalesCardSlice';
import authReducer from './authSlice';
import miscExpenseDataReducer from './miscExpenseDataSlice';
import ictEnquiryReducer from './ictEnquirySlice';
import billInvoiceReducer from './billInvoiceSlice';
import eventsReducer from './eventsSlice';
import testimonialsReducer from './testimonialsSlice';
import learnerAttendanceReducer from './learnerAttendanceSlice';
import profileReducer from './profileSlice';
import ictTrainersByIctIdReducer from './ictTrainersByIctIdSlice';
import ictPreReqReducer from './ictPreReqSlice';
import ictFaqReducer from './ictFaqSlice';
import ictRelatedReducer from './ictRelatedSlice';
import ictRelatedDomainReducer from './ictRelatedDomainSlice';
import vendorsReducer from './vendorsSlice';
import ictBrochureReducer from './ictBrochureSlice';

const store = configureStore({
    reducer: {
        ui: uiReducer,
        studyModes: studyModeReducer,
        studyMaterials: studyMaterialReducer,
        benefits: benefitsReducer,
        hours:hoursReducer,
        feedbacks:feedbacksReducer,
        recordings:recordingsReducer,
        leads:leadsReducer,
        learners:learnersReducer,
        learningBundles:learningBundlesReducer,
        learningModules:learningModulesReducer,
        trainingCards:trainingCardsReducer,
        faq:faqReducer,
        trainingSchedules:trainingSchedulesReducer,
        domains: domainsReducer,
        trainers: trainersReducer,
        empData: empDataReducer,
        ictCost: ictCostReducer,
        accommodations: accommodationsReducer,
        travelData: travelDataReducer,
        tourData: tourDataReducer,
        dcData: dcDataReducer,
        ictSalesCards: ictSalesCardReducer,
        auth: authReducer,
        miscExpenseData: miscExpenseDataReducer,
        ictEnquiry: ictEnquiryReducer,
        billInvoices: billInvoiceReducer,
        events: eventsReducer,
        testimonials: testimonialsReducer,
        learnerAttendance: learnerAttendanceReducer,
        profile: profileReducer,
        ictTrainersByIctId: ictTrainersByIctIdReducer,
        ictPreReq: ictPreReqReducer,
        ictFaq: ictFaqReducer,
        ictRelated: ictRelatedReducer,
        ictRelatedDomain: ictRelatedDomainReducer,
        vendors: vendorsReducer,
        ictBrochure: ictBrochureReducer,
        
    },
});

export default store;
